/* eslint-disable max-len */
import React from 'react';

const TitleOneIcon = props => (
  <svg viewBox="0 0 19 19" {...props}>
    <path
      d="M10 6v8.8a.2.2 0 0 1-.2.2H8.2a.2.2 0 0 1-.2-.2V6H4.2a.2.2 0 0 1-.2-.2V4.2c0-.11.09-.2.2-.2h9.6c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H10zm4 6h-.8a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v3.6a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V12z"
      fillRule="nonzero"
    />
  </svg>
);

export default TitleOneIcon;
